import React, { Component } from "react";
import { readStorageJSON, project, toFixed, replaceTextHTML, loading, GET } from "../components/CustomComponent.js";
import LOGO from "../assets/images/logo.png";
import THBText from "thai-baht-text";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
import "../assets/css/pdf.css";
function parsePythonDictOrJson(str) {
  if (typeof str !== 'string') return str;
  // ค่าเสียแปลงไม่ได้ = null (caller ใช้ค่า default ของหน้าแทน) ห้าม throw
  const asObject = (v) => (v !== null && typeof v === 'object' ? v : null);
  try {
    return asObject(JSON.parse(str));
  } catch (_) {
    try {
      const json = str
        .replace(/True/g, 'true')
        .replace(/False/g, 'false')
        .replace(/None/g, 'null')
        .replace(/'/g, '"');
      return asObject(JSON.parse(json));
    } catch (__) {
      return null;
    }
  }
}

const size = {
  A4: { width: 1116, height: 1578 },
  A5: { width: 1116, height: 1578, zoom: 0.5 },
  "4.5 x 5.5 นิ้ว": { width: 1116, height: 1371, zoom: 0.385 },
  "9 x 11 นิ้ว": { width: 1116, height: 1371, zoom: 0.77 },
  "9 x 5.5 นิ้ว": { width: 1116, height: 685, zoom: 0.77 },
};
export default class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: null,
      setting: {
        size: "", // A4, A5, 4.5 x 5.5 นิ้ว, 9 x 11 นิ้ว, 9 x 5.5 นิ้ว
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        header_1: { status: true, title: "-รูปภาพ" },
        header_2: { status: true, title: "" }, // โครงการ
        header_3: { status: true, title: "" }, // ที่อยู่
        header_4: { status: true, title: "-ใบเสร็จรับเงิน" },
        header_5: { status: true, title: "-เลขที่" },
        header_6: { status: true, title: "-วันที่" },
        header_7: { status: true, title: "-ได้รับเงินจาก" },
        header_8: { status: true, title: "-ที่อยู่" },

        th_1: { status: true, title: "-ลำดับ" },
        th_2: { status: true, title: "-รายการ" },
        th_3: { status: true, title: "-รวมเป็นเงิน" },

        tr_4: { status: true, title: "-รวมเป็นเงิน" },
        tr_5: { status: true, title: "-ปรับปรุงยอดเงิน" },
        tr_6: { status: true, title: "-รวมเป็นเงินทั้งสิ้น" },

        footer_1: { status: true, title: "-จำนวนเงิน (ตัวอักษร)" },
        footer_2: { status: true, title: "" }, // หมายเหตุ
        footer_3: { status: true, title: "-ลงชื่อ" },
        footer_4: { status: true, title: "" }, // ชื่อผู้รับเงิน
        footer_5: { status: true, title: "" }, // ตำแหน่งผู้รับเงิน
      },
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get();
    this.setState({ data: readStorageJSON("DATA_") });
    const setting = Object.entries(this.state.setting);
    for (let item of setting) {
      if (!item[1].status) {
        try {
          let component = document.getElementsByClassName(item[0]);
          for (let co of component) {
            co.classList.add("d-none");
          }
        } catch (e) {}
      }
    }
    if (!this.state.setting.header_1.status && !this.state.setting.header_2.status && !this.state.setting.header_3.status && !this.state.setting.header_5.status && !this.state.setting.header_6.status) {
      document.getElementsByClassName("header_1_2_3_4_5_6")[0].classList.add("d-none");
    }
    if (!this.state.setting.header_7.status && !this.state.setting.header_8.status) {
      document.getElementsByClassName("header_7_8")[0].classList.add("d-none");
    }
    await replaceTextHTML();
    setTimeout(() => {
      window.print();
    }, 1000);
  }

  Get = async () => {
    const settings = readStorageJSON("cds-setting") || {};
    if (settings?.setting_document_custom?.[0]?.invoice_other) {
      const invoice_other = settings.setting_document_custom[0].invoice_other;
      this.setState({ setting: (typeof invoice_other === 'string' ? parsePythonDictOrJson(invoice_other) : invoice_other) || this.state.setting });
    }
    // ดึงข้อมูลโครงการ (รวมรูปหัวกระดาษ) สดจาก API แทนการเชื่อ localStorage ที่อาจเก่ากว่าข้อมูลจริงใน DB
    if (project?.project_id) {
      const fresh = await GET("api/public/project", { project_id: project.project_id });
      if (fresh?.status && fresh.data) {
        this.setState({ picture_paper: fresh.data.picture_paper || "" });
      }
    }
    this.setState({ loading: false });
  };
  render() {
    return (
      <div className="w-100">
        {!this.state.loading && (
          <div 
          className={"mx-auto bg-white border-bottom " + (this.state.setting.size === "9 x 5.5 นิ้ว" ? "pdf-small" : "pdf")} 
          style={{
            ...size[this.state.setting?.size || "A4"],
            paddingLeft: Number(this.state.setting?.paddingLeft),
            paddingRight: Number(this.state.setting?.paddingRight),
            paddingTop: Number(this.state.setting?.paddingTop),
            paddingBottom: Number(this.state.setting?.paddingBottom),
        }}>
          
            <table className="table table-bordered mb-0 header">
              <tr className="header_1_2_3_4_5_6">
                <td rowSpan={2} className="border-bottom-0">
                  <div className="d-flex align-items-center">
                    <img src={this.state.picture_paper || project["picture_paper"] || LOGO} style={{ width: 92, height: 92, objectFit: "contain", marginRight: 6 }} alt="LOGO" className="bg-contain header_1" />
                    <div>
                      <h2 className="fw-bold header_2 px-2 mb-0">{this.state.setting.header_2?.title || ""}</h2>
                      <div className="header_3 px-2">{this.state.setting.header_3?.title.split("\n").map(e=>(<div>{e}</div>)) || ""}</div>
                    </div>
                  </div>
                </td>
                <td className="wpx-250 text-center border-bottom-0 header_4">
                  <h2 className="fw-bold mb-0">ใบแจ้งหนี้อื่นๆ</h2>
                </td>
              </tr>
              <tr className="header_1_2_3_4_5_6">
                <td className="border-bottom-0 wpx-250">
                  <div className="header_5">เลขที่ : {this.state.data?.number}</div>
                  <div className="header_6">วันที่ : {this.state.data?.date}</div>
                </td>
              </tr>
              <tr className="header_7_8">
                <td className="border-bottom-0" colSpan={2}>
                  <div className="header_7">ได้รับเงินจาก : {this.state.data?.cutomer_name}</div>
                  <div className="header_8">ที่อยู่ : {this.state.data?.cutomer_address}</div>
                </td>
              </tr>
            </table>
            <table className="table table-bordered mb-0">
              <tr>
                <td className="py-1 text-center wpx-50 th_1">ลำดับ</td>
                <td className="py-1 th_2 border-right-0 w-100">รายการ</td>
                <td className="py-1 th_2 border-left-0 wpx-130"></td>
                <td className="py-1 text-center wpx-120 th_3">รวมเป็นเงิน</td>
              </tr>
              <tr>
                <td className="pt-1 text-center th_1">1</td>
                <td className="pt-1 border-right-0 th_2">
                  {this.state.data?.title} {this.state.data?.description ? "(" + this.state.data?.description + ")" : ""}
                </td>
                <td className="border-left-0 th_2"></td>
                <td className="text-right th_3">{toFixed(this.state.data?.cost)}</td>
              </tr>
              <tr>
                <td className="text-center th_1" colSpan={4} style={{height:250}}></td>
              </tr>
              <tr>
                <td colSpan={(this.state.setting.th_1.status ? 1 : 0) + (this.state.setting.th_2.status ? 1 : 0)} rowSpan={3} className="border-0">
                  <div className="d-flex">
                    <div className="w-100">
                      <div className="w-100 d-flex position-relative mt-3 text-nowrap footer_1">
                        จำนวนเงิน (ตัวอักษร)
                        <div className="w-100 pl-1 position-relative">
                          ....................................................................................
                          <span className="position-absolute" style={{ left: 6, bottom: 4 }}>
                            {THBText(Number(this.state.data?.total || 0) + Number(this.state.data?.change_satang || 0))}
                          </span>
                        </div>
                      </div>
                      <div className="footer_2">{this.state.setting.footer_2?.title.split("\n").map(e=>(<div>{e}</div>)) || ""}</div>
                    </div>
                    <div className="text-center">
                      <br />
                      <br />
                      <div className="text-nowrap footer_3">ลงชื่อ...............................................ผู้รับเงิน</div>
                      <div className="footer_4">({this.state.setting.footer_4.title || ""})</div>
                      <div className="footer_5">{this.state.setting.footer_5.title || ""}</div>
                    </div>
                  </div>
                </td>
                <td className="text-right pr-1 border-0 tr_4 py-2">รวมเป็นเงิน</td>
                <td className="text-right tr_4 py-2">{toFixed(this.state.data?.total)}</td>
              </tr>
              <tr className="tr_5">
                <td className="text-right pr-1 border-0 py-2">ปรับปรุงยอดเงิน</td>
                <td className="text-right py-2">{toFixed(this.state.data?.change_satang)}</td>
              </tr>
              <tr className="tr_6">
                <td className="text-right pr-1 border-0 py-2">รวมเป็นเงินทั้งสิ้น</td>
                <td className="text-right py-2">{toFixed(Number(this.state.data?.total) + Number(this.state.data?.change_satang))}</td>
              </tr>
            </table>
          </div>
        )}
      </div>
    );
  }
}
